/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface HelpDeviceLogoFileNameGet$Params {

/**
 * Logo file name (with or without `.webp` extension).
 */
  fileName: string;
}

export function helpDeviceLogoFileNameGet(http: HttpClient, rootUrl: string, params: HelpDeviceLogoFileNameGet$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, helpDeviceLogoFileNameGet.PATH, 'get');
  if (params) {
    rb.path('fileName', params.fileName, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as WearablesStrictHttpResponse<void>;
    })
  );
}

helpDeviceLogoFileNameGet.PATH = '/Help/DeviceLogo/{fileName}';
